<div class="label-container">
    <div>
        <label class="clickable-label" routerLink="/dashboard/explore"> Rap Almanac </label>
        <img src="../assets/images/filled.svg" />
    </div>

    <label class="non-clickable-label">API Docs</label>

</div>
<div class="api-docs-container">


    <!-- Navigation Tabs -->
    <div class="api-nav">
        <div class="nav-container">
            <button class="nav-tab" [class.active]="selectedTab === 'overview'" (click)="selectTab('overview')">
                Overview
            </button>
            <button class="nav-tab" [class.active]="selectedTab === 'authentication'"
                (click)="selectTab('authentication')">
                Authentication
            </button>
            <button class="nav-tab" [class.active]="selectedTab === 'endpoints'" (click)="selectTab('endpoints')">
                API Endpoints
            </button>
        </div>
    </div>

    <!-- Content Area -->
    <div class="api-content">

        <!-- Overview Tab -->
        <div class="tab-content" *ngIf="selectedTab === 'overview'">
            <div class="content-section">
                <h2>API Overview</h2>
                <p>The Rap Almanac API provides access to a comprehensive database of hip-hop music, artists, albums,
                    and
                    related metadata. Our RESTful API allows you to search, retrieve, and manage music data
                    programmatically.</p>

                <div class="feature-grid">
                    <div class="feature-card">
                        <i class="fas fa-search"></i>
                        <h3>Advanced Search</h3>
                        <p>Search across songs, artists, albums with powerful filtering options</p>
                    </div>
                    <div class="feature-card">
                        <i class="fas fa-database"></i>
                        <h3>Rich Metadata</h3>
                        <p>Comprehensive information including lyrics, credits, and release data</p>
                    </div>
                    <div class="feature-card">
                        <i class="fas fa-chart-line"></i>
                        <h3>Analytics</h3>
                        <p>Access trending data and popularity metrics</p>
                    </div>
                    <div class="feature-card">
                        <i class="fas fa-lock"></i>
                        <h3>Secure Access</h3>
                        <p>OAuth 2.0 authentication with role-based permissions</p>
                    </div>
                </div>

                <div class="api-info">
                    <h3>Base URL</h3>
                    <div class="code-block">
                        <code>{{apiBaseUrl}}</code>
                        <button class="copy-btn" (click)="copyToClipboard(apiBaseUrl)">
                            <i class="bi bi-copy"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Authentication Tab -->
        <div class="tab-content" *ngIf="selectedTab === 'authentication'">
            <div class="content-section">
                <!-- Authentication Information Section -->
                <div class="pdf-section">
                    <!-- <div class="pdf-header"> -->
                    <!-- <h3><i class="fas fa-key"></i> Invoking Rap Almanac APIs V2 in STAGE env</h3> -->
                    <!-- <p>Access Token and API documentation for V2 APIs</p> -->
                    <!-- </div> -->
                    <div class="auth-content">
                        <div class="auth-info">
                            <h4>Access Token</h4>

                            <ng-container *ngIf="hasApiAccess; else apiUpsell">
                                <p>To invoke the Rap Almanac API, obtain an access token using your
                                    username and password.</p>

                                <div class="api-docs-links">
                                    <p>Read the API documentation for help <a href="javascript:void(0)"
                                            (click)="selectTab('endpoints')" class="inline-link">API Docs</a></p>
                                    <!-- <p><strong>GET ACCESS TOKEN API DOC:</strong> <a
                                            [href]="apiDocsUrl" target="_blank"
                                            class="inline-link">API Docs</a></p> -->
                                </div>

                                <div class="api-endpoint">
                                    <h4> API URL for getting access token</h4>
                                    <div class="endpoint-card">
                                        <div class="method-badge method-get">GET</div>
                                        <div class="endpoint-url">
                                            <code>{{apiBaseUrl}}/v2/access-token</code>
                                            <button class="copy-btn"
                                                (click)="copyToClipboard(apiBaseUrl + '/v2/access-token')">
                                                <i class="bi bi-copy"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div class="request-headers">
                                    <h4><i class="fas fa-list"></i> Required Request Headers</h4>
                                    <div class="info-card">
                                        <p><strong>Example Postman Request:</strong></p>
                                        <div class="headers-list">
                                            <div class="header-item">
                                                <span class="header-label">Method:</span>
                                                <div class="method-badge method-get">GET</div>
                                            </div>
                                            <div class="header-item">
                                                <span class="header-label">URL:</span>
                                                <code>{{apiBaseUrl}}/v2/access-token</code>

                                            </div>
                                            <!-- <div class="header-item">
                                                <span class="header-label">client-id:</span>
                                                <code>1tu2lg3p9vj4vth6duifqdm7gc</code>
                                                <button class="copy-btn"
                                                    (click)="copyToClipboard('1tu2lg3p9vj4vth6duifqdm7gc')">
                                                    <i class="fas fa-copy"></i>
                                                </button>
                                            </div> -->
                                            <div class="header-item">
                                                <span class="header-label">Authorization:</span>
                                                <code>Basic c21h****************************************</code>
                                                <button class="copy-btn"
                                                    (click)="copyToClipboard('Basic c21h****************************************')">
                                                    <i class="fas fa-copy"></i>
                                                </button>
                                            </div>
                                            <div class="header-item">
                                                <span class="header-label">User-Agent:</span>
                                                <code>PostmanRuntime/7.33.0</code>
                                            </div>
                                            <div class="header-item">
                                                <span class="header-label">Accept:</span>
                                                <code>*/*</code>
                                            </div>
                                        </div>
                                        <div class="response-info">
                                            <p><strong>Expected Response:</strong> <span class="status-success">200
                                                    OK</span> (Response time: ~3.39s)</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="response-body">
                                    <h4><i class="fas fa-code"></i> Response Body</h4>
                                    <div class="info-card">
                                        <p><strong>Actual Response from API:</strong></p>
                                        <div class="code-block">
                                            <code>{{'{'}}<br>
      "accessToken": "eyJra*******************************************************************"<br>
    {{'}'}}</code>

                                        </div>

                                        <div class="token-info">
                                            <h5>Token Information:</h5>
                                            <ul>
                                                <li><strong>Token Type:</strong> JWT (JSON Web Token)</li>
                                                <li><strong>Algorithm:</strong> RS256 (RSA SHA-256)</li>
                                                <li><strong>Issuer:</strong> Amazon Cognito</li>
                                                <li><strong>Groups:</strong> Developer</li>
                                                <li><strong>Token Use:</strong> Access token for API authentication</li>
                                                <li><strong>Scope:</strong> aws.cognito.signin.user.admin</li>
                                            </ul>
                                        </div>

                                        <div class="usage-note">
                                            <p><strong>Usage:</strong> Include this token in subsequent API requests as:</p>
                                            <div class="code-block">
                                                <code>Authorization: Bearer eyJra***********************************************************************</code>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-template #apiUpsell>
                                <p>Rap Almanac API access is available to Enterprise User accounts only.</p>
                                <p>Want API access? Upgrade to an Enterprise account via your <a routerLink="/profile"
                                        class="inline-link">Profile Page</a>. If you believe you should already have API
                                    access, please contact your administrator.</p>
                            </ng-template>
                        </div>
                    </div>
                </div>


            </div>
        </div>

        <!-- API Endpoints Tab -->
        <div class="tab-content" *ngIf="selectedTab === 'endpoints'">
            <div class="content-section">
                <!-- External API Documentation Section -->
                <div class="external-docs-section">
                    <div class="external-docs-header">
                        <h3><i class="fas fa-external-link-alt"></i> Live API Documentation</h3>
                        <p>Access the interactive API documentation and testing interface</p>
                    </div>
                    <div class="external-docs-content">
                        <div class="docs-info">
                            <!-- <h4>Interactive API Explorer</h4>
                            <p>Use our live documentation to explore endpoints, test requests, and see real-time
                                responses.</p> -->
                            <div class="docs-url">
                                <code>{{apiDocsUrl}}</code>
                                <button class="copy-btn" (click)="copyToClipboard(apiDocsUrl)">
                                    <i class="bi bi-copy"></i>
                                </button>
                            </div>
                        </div>
                        <div class="docs-actions">
                            <a [href]="apiDocsUrl" target="_blank" class="btn-primary">
                                <i class="fas fa-rocket"></i> Open API Explorer
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>